import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { resolvePath } from 'react-router';
import pages from 'pages';
import { ArrowRightIcon } from 'shared/components/icons/ArrowRightIcon';
import { PlayIcon } from 'shared/components/icons/PlayIcon';
import {
  VideoResourcesCardContent,
  VideoPlaceholder,
  ViewResourcesLink,
} from './VideoResourcesCard.styles';
import { Card } from '../../../../shared/components/Card/Card';

export function VideoResourcesCard() {
  const { t } = useTranslation();

  return (
    <Card
      title={t('support&FAQs.videoResources.title')}
      icon={{
        element: <PlayIcon />,
      }}
      width="100%"
    >
      <VideoResourcesCardContent>
        <VideoPlaceholder>
          {t('support&FAQs.faqCategories.agreementTransfer.sidebar.videoPlaceholder')}
        </VideoPlaceholder>
        <ViewResourcesLink
          as={Link}
          to={resolvePath(`/${pages.SUPPORT}/${pages.VIDEO_RESOURCES}`).pathname}
        >
          {t('support&FAQs.faqCategories.agreementTransfer.sidebar.goToVideoResources')}
          <ArrowRightIcon />
        </ViewResourcesLink>
      </VideoResourcesCardContent>
    </Card>
  );
}

export default VideoResourcesCard;
